<ion-row>
  <ion-col class="bow-white">
    <div item-icon-left></div>
  </ion-col>
</ion-row>
<div class="name-address-block" [ngClass]="{'selectedButton' : menuData?.openState}">
  <ion-row>
    <ion-col class="name">
      @if (menuData) {
        <span item-name-left>{{menuData?.name}}</span>
      }
    </ion-col>
  </ion-row>
  <ion-row class="tidy-address">
    <ion-col class="address">
      @if (menuData) {
        <span item-address-left>{{menuData?.currentAddress}}</span>
      }
    </ion-col>
    <ion-col class="tidy-icon">
      <ion-icon item-icon-right [name]="'caret-' + (menuData?.openState ? 'up' : 'down')" />
    </ion-col>
  </ion-row>
</div>
